<h2>Monitoring Jobs and Events</h2>

<p-tabs class="wal-tabs" [value]="tabMonitoringIndex">

  <p-tablist>

    @if(isSummaryShown) {
      <p-tab [value]="'Jobs Summary'">
        <span class="tab-label">
          <i class="pi pi-list" aria-hidden="true"></i>
          <span class="ml-2">Jobs Summary</span>
        </span>
      </p-tab>
    }

      <p-tab [value]="'Job Executions'">
        <span class="tab-label">
          <i class="pi pi-tags" aria-hidden="true"></i>
          <span class="ml-2">Job Executions</span>
        </span>
      </p-tab>

      <p-tab [value]="'Event Occurences'">
        <span class="tab-label">
          <i class="pi pi-bell" aria-hidden="true"></i>
          <span class="ml-2">Event Occurences</span>
        </span>
      </p-tab>

      <p-tab [value]="'Task Hierarchy'">
        <span class="tab-label">
          <i class="pi pi-sitemap" aria-hidden="true"></i>
          <span class="ml-2">Task Hierarchy</span>
        </span>
      </p-tab>

  </p-tablist>  

    <p-tabpanels>

      <!--  J O B S  S U M M A R Y   P A N E L  -->

      <p-tabpanel [value]="'Jobs Summary'">

            <div class="grid">
              <div class="col-8">
                <p-chart type="bar" [data]="jobSummary" [options]="optionsSummary"></p-chart>
                <p-button label="Refresh" icon="pi refresh" iconPos="left" (click)="update($event)" 
                  styleClass="p-button-success wal-success p-button-raised p-button-rounded" ></p-button>
              </div>
              <div class="col-1"></div>
              <div class="col-2">
                <p-chart type="doughnut" [data]="jobStatus" [options]="optionsStatus"></p-chart>
                <p-chart type="doughnut" [data]="environmentCount" [options]="optionsEnvironmentCount"></p-chart>
              </div>
            </div>

      </p-tabpanel>

      <!--  J O B   E X E C U T I O N   P A N E L  -->

      <p-tabpanel [value]="'Job Executions'">

        <!--  J O B   E X E C U T I O N   C R I T E R I A  -->
        <div class="wal-criteria-row col-10">

          <div class="wal-criteria-item">
              <label for="envRegion" class="margin-left">Region: </label>
            <p-select id ="envRegion" [options]="envRegions" [(ngModel)]="selectedRegion" class="prime-dropdown" 
              (onChange)="onChangeEnvRegion($event)"
              [filter]="false" placeholder="Enviromental Region:" [editable]="false">
            </p-select>
          </div>

          <div class="wal-criteria-item">
              <label for="brandCode" class="margin-left">Brand: </label>
            <p-select id ="brandCode" [options]="brandCodes" [(ngModel)]="selectedBrandCode" [filter]="true" 
                class="prime-dropdown" placeholder="Brand Code:" [editable]="false"  class="margin-left">
            </p-select>
          </div>

          <div class="wal-criteria-item">
              <label for="jobCode" class="margin-left">Job: </label>
              <p-select id ="jobCode" [options]="jobCodes" [(ngModel)]="selectedJobCode" [filter]="true" 
                class="prime-dropdown" placeholder="Job Code:" [editable]="false"  class="margin-left">
              </p-select>
          </div>

          <div class="wal-criteria-item">
              <label for="jobDateFrom" class="margin-left">From: </label>
              <p-datePicker id="jobDateFrom" [(ngModel)]="selectedJobDateFrom" dateFormat="yy-mm-dd" placeholder="Date From:"
                [showIcon]="true" placeholder="From">
              </p-datePicker>
          </div>              

          <div class="wal-criteria-item">
              <label for="jobDateTo" class="margin-left">To: </label>
              <p-datePicker id="jobDateTo" [(ngModel)]="selectedJobDateTo" dateFormat="yy-mm-dd" placeholder="Date To:"
                [showIcon]="true" placeholder="To">
              </p-datePicker>
          </div>

          <div class="wal-criteria-item">
              <div class="checkbox-row">
                <label for="isIncludedMaintenenceJobs" class="margin-left">Maintenance: </label>
                <p-checkbox [(ngModel)]="isIncludedMaintenenceJobs" id="enabled" [binary]="true"></p-checkbox>
              </div>
          </div>

          <div class="wal-criteria-item wal-criteria-actions">
              <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onJobSearchClick($event)"></p-button>
              <p-button label="Next" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="onJobNextClick($event)"></p-button>
              <p-button label="Clear" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="onJobClearClick($event)"></p-button>
          </div>

          <div class="wal-criteria-item wal-criteria-status">
            <div class="col-2" id="idSpinner" [hidden]="isJobsSpinnerHidden">
              <div class="loader"></div>  
            </div>
          </div>          

        </div>

        <!--  J O B   E X E C U T I O N   G R I D  -->

        <div class="grid">
          <div class="col-8">

            <p-table #dtJobs [columns]="jobCols" [value]="jobs" selectionMode="single" [(selection)]="selectedJob" 
                class="wal-table" [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true"
                sortMode="multiple" (onRowSelect)="onJobRowSelect($event)" [paginator]="true" [rows]="15">
              <ng-template pTemplate="caption">
                List of Jobs Execution
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                    @for (col of columns; track col.field) {
                        <th [pSortableColumn]="col.field"
              							[style.display]="col.display"
                            [style.width]="col.width">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    }
                </tr>

                <tr>
                    @for (col of columns; track col.field) {
                        <th [style.width]="col.width" [style.display]="col.display">
                            @switch (col.field) {
                                @case ('brandCode') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dtJobs.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('jobName') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dtJobs.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('status') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dtJobs.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('environment') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dtJobs.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('host') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dtJobs.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('exitCode') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dtJobs.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @default {
                                }
                            }
                        </th>
                    }

                </tr>
    
            </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                </tr>
            </ng-template>
            <ng-template pTemplate="summary" let-rowData>
                <div style="text-align:left">
                </div>
              </ng-template>    
            </p-table> 

          </div>
        </div>


      </p-tabpanel>

      <p-tabpanel [value]="'Event Occurences'">

        <!-- E V E N T   O C C U R R E N C E   C R I T E R I A  -->
        <div class="wal-criteria-row col-7">

          <div class="wal-criteria-item">
              <label for="eventName" class="margin-left">Event:</label>
              <p-select id ="eventName" [options]="eventNames" [(ngModel)]="selectedEventName" [filter]="true" 
                class="prime-dropdown" placeholder="Event Name:" [editable]="false" class="margin-left">
              </p-select>
          </div>

          <div class="wal-criteria-item">
              <label for="eventDateFrom" class="margin-left"> From:</label>
              <p-datePicker id="eventDateFrom" [(ngModel)]="selectedEventDateFrom" dateFormat="yy-mm-dd" 
                placeholder="Date From:" [showIcon]="true" class="margin-left">
              </p-datePicker>
          </div>

          <div class="wal-criteria-item">
              <label for="eventDateTo" class="margin-left"> To:</label>
              <p-datePicker id="eventDateTo" [(ngModel)]="selectedEventDateTo" dateFormat="yy-mm-dd" 
                placeholder="Date To:" [showIcon]="true" class="margin-left">
              </p-datePicker>
          </div>

          <div class="wal-criteria-item wal-criteria-actions">
            <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onEventSearchClick($event)"></p-button>
             <p-button label="Next" styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="onEventNextClick($event)"></p-button>
             <p-button label="Clear" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="onEventClearClick($event)"></p-button>
          </div> 

          <div class="wal-criteria-item wal-criteria-status">
            <div class="col-2" id="idSpinner" [hidden]="isEventsSpinnerHidden">
              <div class="loader"></div>  
            </div>
          </div>

        </div>  

        <!-- E V E N T   O C C U R R E N C E   G R I D  -->

          <div class="grid">
            <div class="col-8">

              <p-table #dtEvents [columns]="eventCols" [value]="events" selectionMode="single" [(selection)]="selectedEvent" 
                  class="wal-table" [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true"
                  sortMode="multiple" (onRowSelect)="onEventRowSelect($event)" [paginator]="true" [rows]="15">
                <ng-template pTemplate="caption">
                  List of Event Occurrences
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    @for (col of columns; track col.field) {
                        <th [pSortableColumn]="col.field"
                            [style.display]="col.display"
                            [style.width]="col.width">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    }
                  </tr>
                  <tr>
                    @for (col of columns; track col.field) {
                        <th [style.width]="col.width" [style.display]="col.display">
                            @switch (col.field) {
                                @case ('eventName') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dtEvents.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('sourceEnvironment') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dtEvents.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @default {
                                }
                            }
                        </th>
                    }

                  </tr>  
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                  </tr>
              </ng-template>
              <ng-template pTemplate="summary" let-rowData>
                  <div style="text-align:left">
                  </div>
                </ng-template>    
              </p-table> 

            </div>
          </div>

      </p-tabpanel>

      <p-tabpanel [value]="'Task Hierarchy'">

        <div style="margin-bottom: 1rem">
          <button pButton type="button" label="Expand all" (click)="expandAll()" style="margin-right: .5rem" class="ui-button-success"></button>
          <button pButton type="button" label="Collapse all" (click)="collapseAll()" class="ui-button-info"></button>
        </div>

        <p-tree
          [value]="taskTree"
          selectionMode="single">
        </p-tree>  

      </p-tabpanel>

    </p-tabpanels>        


</p-tabs>


<!-- E V E N T   O C C U R R E N C E   D E T A I L S  -->

<p-dialog appendTo="body" header="Event Occurance Details" [(visible)]="eventDisplayDialog" [focusOnShow]="false" 
    styleClass="wal-dialog"
    [responsive]="true" showEffect="fade" [modal]="true"  [style]="{width: '600px'}">
  <div class="grid ui-fluid md-2" *ngIf="event">

    <div class="field grid">
      <label for="scheduledEventOccurrenceId" class="col-fixed label" style="width: 15em">Event Occurrence Id:</label>
      <div class="col">
          <input pInputText id="scheduledEventOccurrenceId" [(ngModel)]="event.scheduledEventOccurrenceId" autofocus readonly>
      </div>
    </div>      

    <div class="field grid">
      <label for="eventName" class="col-fixed label" style="width: 15em">Event Name:</label>
      <div class="col">
          <input pInputText id="eventName" [(ngModel)]="event.eventName" readonly style="width: 25em"/>
      </div>
    </div>      

    <div class="field grid">
      <label for="eventDescription" class="col-fixed label" style="width: 15em">Event Description:</label>
      <div class="col">
          <input pInputText id="eventDescription" [(ngModel)]="event.eventDescription" readonly style="width: 25em">
      </div>
    </div>      

    <div class="field grid">
      <label for="sourceEnvironment" class="col-fixed label" style="width: 15em">Env. Region:</label>
      <div class="col">
          <input pInputText id="sourceEnvironment" [(ngModel)]="event.sourceEnvironment" readonly>
      </div>
    </div>      

    <div class="field grid">
      <label for="sourceHost" class="col-fixed label" style="width: 15em">Source Host:</label>
      <div class="col">
          <input pInputText id="sourceHost" [(ngModel)]="event.sourceHost" readonly>
      </div>
    </div>      

    <div class="field grid">
      <label for="eventTimestamp" class="col-fixed label" style="width: 15em">Event Timestamp:</label>
      <div class="col">
          <input pInputText id="eventTimestamp" [(ngModel)]="event.eventTimestamp"  readonly>
      </div>
    </div>      

    <div class="field grid">
      <label for="eventAttributes" class="col-fixed label" style="width: 15em">Event Attributes:</label>
      <div class="col">
          <textarea [rows]="3" [cols]="30" pTextarea autosize id="eventAttributes" [(ngModel)]="event.eventAttributes" 
            readonly style="width: 25em"></textarea>
       </div>
    </div>      

</div>
  <p-ng-template #footer>
      <div class="footer-actions">
          <p-button label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="eventCancel()"></p-button>
      </div>
  </p-ng-template>
</p-dialog>

 <!--  J O B   E X E C U T I O N   D E T A I L S  -->

 <p-dialog appendTo="body" header="Job Details" [(visible)]="jobDisplayDialog" [focusOnShow]="false" 
    styleClass="wal-dialog"
    [responsive]="true" showEffect="fade" [modal]="true"  [style]="{width: '50%'}">
  <div class="grid ui-fluid md-2" *ngIf="job">


    <p-tabs class="wal-tabs" [value]="tabJobDetailsIndex" (onChange)="onActiveTabChange($event)">

      <p-tablist>

        <p-tab [value]="'Details'">
          <span class="tab-label">
            <i class="pi pi-volume-up" aria-hidden="true"></i>
            <span class="ml-2">Details</span>
          </span>
        </p-tab>

        <p-tab [value]="'Steps'">
          <span class="tab-label">
            <i class="pi pi-sort-amount-down" aria-hidden="true"></i>
            <span class="ml-2">Steps</span>
          </span>
        </p-tab>

        <p-tab [value]="'Parameters'">
          <span class="tab-label">
            <i class="pi pi-list" aria-hidden="true"></i>
            <span class="ml-2">Parameters</span>
          </span>
        </p-tab>

        <p-tab [value]="'Additional Info'">
          <span class="tab-label">
            <i class="pi pi-info" aria-hidden="true"></i>
            <span class="ml-2">Additional Info</span>
          </span>
        </p-tab>

      </p-tablist>  

      <p-tabpanels [(value)]="tabJobDetailsIndex" (valueChange)="onActiveTabChange($event)">

        <p-tabpanel [value]="'Details'">

          <div class="field grid">
            <label for="jobUuid" class="col-fixed label" style="width: 15em">Job Uuid:</label>
            <div class="col">
                <input pInputText id="jobUuid" [(ngModel)]="job.jobUuid" autofocus readonly>
            </div>
          </div>      

          <div class="field grid">
            <label for="jobUuid" class="col-fixed label" style="width: 15em">Job Code:</label>
            <div class="col">
                <input pInputText id="jobUuid" [(ngModel)]="job.jobUuid" readonly style="width: 40em">
            </div>
          </div>      

          <div class="field grid">
            <label for="jobName" class="col-fixed label" style="width: 15em">Job Name:</label>
            <div class="col">
                <input pInputText id="jobName" [(ngModel)]="job.jobName"  readonly style="width: 40em">
            </div>
          </div>      

          <div class="field grid">
            <label for="jobDescription" class="col-fixed label" style="width: 15em">Job Description:</label>
            <div class="col">
                <input pInputText id="jobDescription" [(ngModel)]="job.jobDescription" style="width: 40em" readonly>
            </div>
          </div>      

          <div class="field grid">
            <label for="brandCode" class="col-fixed label" style="width: 15em">Brand Code:</label>
            <div class="col">
                <input pInputText id="brandCode" [(ngModel)]="job.brandCode"  readonly>
            </div>
          </div>      

          <div class="field grid">
            <label for="status" class="col-fixed label" style="width: 15em">Job Status:</label>
            <div class="col">
                <input pInputText id="status" [(ngModel)]="job.status" readonly>
            </div>
          </div>      

          <div class="field grid">
            <label for="environment" class="col-fixed label" style="width: 15em">Env. Region:</label>
            <div class="col">
                <input pInputText id="environment" [(ngModel)]="job.environment" readonly>
            </div>
          </div>      

          <div class="field grid">
            <label for="host" class="col-fixed label" style="width: 15em">Host:</label>
            <div class="col">
                <input pInputText id="host" [(ngModel)]="job.host"  readonly>
            </div>
          </div>      

          <div class="field grid">
            <label for="startTimestamp" class="col-fixed label" style="width: 15em">Started:</label>
            <div class="col">
                <input pInputText id="startTimestamp" [(ngModel)]="job.startTimestamp"  readonly>
            </div>
          </div>      

          <div class="field grid">
            <label for="endTimestamp" class="col-fixed label" style="width: 15em">Finished:</label>
            <div class="col">
                <input pInputText id="endTimestamp" [(ngModel)]="job.endTimestamp"  readonly>
            </div>
          </div>      

          <div class="field grid">
            <label for="exitMessage" class="col-fixed label" style="width: 15em">Exit Message:</label>
            <div class="col">
                <input pInputText id="exitMessage" [(ngModel)]="job.exitMessage"  readonly>
            </div>
          </div>      

        </p-tabpanel>

        <p-tabpanel [value]="'Steps'">

          <p-table #dt [columns]="stepCols" [value]="steps" selectionMode="single" 
              class="wal-table" dataKey="seqNo" [expandedRowKeys]="expandedRows"
              (onRowExpand)="onRowExpand($event)"
              (onRowCollapse)="onRowCollapse($event)"
              sortMode="multiple" (onRowSelect)="onStepRowSelect($event)" [paginator]="true" [rows]="5">
            <ng-template pTemplate="caption">
              List of Job Steps
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width: 2.25em"></th>
                @for (col of columns; track col.field) {
                  <th [pSortableColumn]="col.field"
                    [style.display]="col.display"
                    [style.width]="col.width">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </th>
                }
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
              <tr>
                <td style="width:5%">
                  <button type="button" pButton pRipple [pRowToggler]="rowData" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                @for (col of columns; track col.field) {
                  <td [style.width]="col.width" [style.display]="col.display">
                    {{ rowData[col.field] }}
                  </td>
                }
              </tr>
            </ng-template>

            <ng-template pTemplate="expandedrow" let-rowData>
              <tr>
                <td [attr.colspan]="2">
                  <div class="ui-g ui-fluid" style="font-size:11px;padding:7px">
                      <div class="ui-g-12 ui-md-9">
                          <div class="grid">
                            <div class="col-12">
                              <b>Parameters:</b> {{rowData.parameters}}
                          </div>
                          <div class="col-12">
                                  <b>Additional Info:</b> {{rowData.additionalInfo}}
                              </div>
                          </div>
                      </div>
                  </div>
                </td>
              </tr>
            </ng-template>

          </p-table> 

          <p-table #dt [columns]="chunkCols" [value]="chunks" selectionMode="single"  dataKey="seqNo"
              class="wal-table" sortMode="multiple"  [paginator]="true" [rows]="5">
            <ng-template pTemplate="caption">
              List of Step Chunks
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width: 2.25em"></th>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
              <tr [pSelectableRow]="rowData">
                  <td [ngStyle]="{'width': '5%'}">
                    <button type="button" pButton pRipple [pRowToggler]="rowData" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                  </td>
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
              <tr>
                  <td [attr.colspan]="columns.length + 1">
                      <div class="ui-g ui-fluid" style="font-size:11px;padding:7px">
                          <div class="ui-g-12 ui-md-9">
                              <div class="grid">
                                <div class="col-12">
                                  <b>Parameters:</b> {{rowData.parameters}}
                              </div>
                              <div class="col-12">
                                      <b>Additional Info:</b> {{rowData.additionalInfo}}
                                  </div>
                              </div>
                          </div>
                      </div>
                  </td>
              </tr>
            </ng-template>
          </p-table> 


        </p-tabpanel>

        <p-tabpanel [value]="'Parameters'">

          <div class="col-7">
            <p-table #dt [columns]="paramCols" [value]="params" selectionMode="single" 
                class="wal-table" sortMode="multiple" [paginator]="true" [rows]="10">
              <ng-template pTemplate="header" let-columns>
                <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                </tr>
              </ng-template>
            </p-table> 
          </div>

        </p-tabpanel>

        <p-tabpanel [value]="'Additional Info'">

          <div class="col-8">
            <p-table #dt [columns]="paramCols" [value]="additionalInfo" selectionMode="single" 
                class="wal-table" sortMode="multiple" [paginator]="true" [rows]="10">
              <ng-template pTemplate="header" let-columns>
                <tr>
						@for (col of columns; track col.field) {
							<th [pSortableColumn]="col.field"
								[style.display]="col.display"
								[style.width]="col.width">
								{{ col.header }}
								<p-sortIcon [field]="col.field"></p-sortIcon>
							</th>
						}
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
                </tr>
              </ng-template>
            </p-table> 
        </div>

        </p-tabpanel>

      </p-tabpanels>        

    </p-tabs>
  
  </div>


  <p-ng-template #footer>
      <div class="footer-actions">
          <p-button label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="jobCancel()"></p-button>
      </div>
  </p-ng-template>
</p-dialog>

<p-confirmDialog  class="lf-confirm-dialog" appendTo="body"></p-confirmDialog>


